import _classCallCheck from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\haouari-n\\Desktop\\CrateV2\\reactcrate\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/**This class is to add functions for the main class when display is true */
export var CrateDecorator =
/*#__PURE__*/
function () {
  function CrateDecorator() {
    _classCallCheck(this, CrateDecorator);
  }

  _createClass(CrateDecorator, null, [{
    key: "addMoveShortcuts",

    /**
     * add ctrl+left arrow and ctrl+right arrow shortcuts for the editor
     * @param crate  crate instance
     */
    value: function addMoveShortcuts(crate) {
      // custom prev next page event
      if (!crate.addMoveShortcuts) {
        crate.addMoveShortcuts = function () {
          var _this = this;

          var codes = {
            37: 'prev',
            39: 'next'
          };
          document.addEventListener && // Modern browsers only
          document.addEventListener('keydown', function (e) {
            var code = codes[e.keyCode];

            if ((e.ctrlKey || e.metaKey) && code) {
              var evt = document.createEvent('Event');
              evt.initEvent(code, true, false);
              e.target.dispatchEvent(evt); // dispatch on current target. Event will bubble up to window

              e.preventDefault(); // opera defaut fix
            }
          }, false);
          $(document).on('next', function () {
            console.log('nnnnnext');

            _this.moveToNext();
          });
          $(document).on('prev', function () {
            console.log('pppppprev');

            _this.moveToPrevious();
          });
        };

        crate.addMoveShortcuts();
      }
    }
    /**
     * add the resize event to focus always on the specific editor
     * @param {*} crate
     */

  }, {
    key: "addResize",
    value: function addResize(crate) {
      if (!crate.Resize) {
        crate.resize = function () {
          var _this2 = this;

          this.resizeTimeout;
          $(window).resize(function () {
            clearTimeout(_this2.resizeTimeout);
            _this2.resizeTimeout = setTimeout(function () {
              _this2.focusInToDocument(_this2.actualSessionIndex);

              clearTimeout(_this2.resizeTimeout);
              console.log('resiiize');
            }, 200);
          });
        };

        crate.resize();
      }
    }
  }]);

  return CrateDecorator;
}();